export const familyMemberConstant = {
    FAMILY_MEMBER_LIST_REQUEST: 'USERS_FAMILY_MEMBER_LIST_REQUEST',
    FAMILY_MEMBER_LIST_SUCCESS: 'USERS_FAMILY_MEMBER_LIST_SUCCESS',
    FAMILY_MEMBER_LIST_FAILURE: 'USERS_FAMILY_MEMBER_LIST_FAILURE',
    RELATION_LIST_REQUEST: 'RELATION_LIST_REQUEST',
    RELATION_LIST_SUCCESS: 'RELATION_LIST_SUCCESS',
    RELATION_LIST_FAILURE: 'RELATION_LIST_FAILURE',
};



// WEBPACK FOOTER //
// ./src/store/constants/familyMember.constants.js